module.exports = __webpack_public_path__ + "static/media/medium-m.1e3c8a70.svg";